/**
 * King Ape header — Shop mega panel (desktop only).
 * Hover bridge between trigger and full-width panel; focus + Escape support.
 */
(function () {
  var MQ = '(min-width: 768px)';
  var CLOSE_DELAY_MS = 180;

  var header = document.querySelector('.ka-site-header');
  var trigger = document.getElementById('ka-shop-mega-trigger');
  var panel = document.getElementById('ka-shop-mega-panel');
  if (!header || !trigger || !panel) return;

  var mq = window.matchMedia(MQ);
  var closeTimer = null;
  var open = false;

  function isDesktop() {
    return mq.matches;
  }

  function clearCloseTimer() {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function setOpen(next) {
    if (!isDesktop()) return;
    clearCloseTimer();
    open = next;
    header.classList.toggle('ka-header--shop-mega-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  function scheduleClose() {
    clearCloseTimer();
    closeTimer = window.setTimeout(function () {
      closeTimer = null;
      setOpen(false);
    }, CLOSE_DELAY_MS);
  }

  function onTriggerEnter() {
    if (!isDesktop()) return;
    clearCloseTimer();
    setOpen(true);
  }

  function onTriggerLeave(e) {
    if (!isDesktop()) return;
    var related = e.relatedTarget;
    if (related && panel.contains(related)) return;
    scheduleClose();
  }

  function onPanelEnter() {
    if (!isDesktop()) return;
    clearCloseTimer();
    setOpen(true);
  }

  function onPanelLeave(e) {
    if (!isDesktop()) return;
    var related = e.relatedTarget;
    if (related && (trigger.contains(related) || panel.contains(related))) return;
    scheduleClose();
  }

  function onFocusIn(e) {
    if (!isDesktop()) return;
    var t = e.target;
    if (trigger.contains(t) || panel.contains(t)) setOpen(true);
  }

  function onFocusOut() {
    if (!isDesktop()) return;
    window.setTimeout(function () {
      if (!isDesktop()) return;
      var a = document.activeElement;
      if (a && (trigger.contains(a) || panel.contains(a))) return;
      setOpen(false);
    }, 0);
  }

  function onKeydown(e) {
    if (!isDesktop() || e.key !== 'Escape' || !open) return;
    if (!header.contains(document.activeElement)) return;
    e.preventDefault();
    setOpen(false);
    trigger.focus();
  }

  trigger.addEventListener('mouseenter', onTriggerEnter);
  trigger.addEventListener('mouseleave', onTriggerLeave);
  panel.addEventListener('mouseenter', onPanelEnter);
  panel.addEventListener('mouseleave', onPanelLeave);
  header.addEventListener('focusin', onFocusIn);
  header.addEventListener('focusout', onFocusOut);
  document.addEventListener('keydown', onKeydown);

  function onMqChange() {
    clearCloseTimer();
    if (!mq.matches) {
      open = false;
      header.classList.remove('ka-header--shop-mega-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('hidden', '');
    }
  }

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', onMqChange);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(onMqChange);
  }
})();
